var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapper,{tag:"component",class:_vm.classObject,attrs:{"to":_vm.to,"replace":_vm.replace,"append":_vm.append,"exact":_vm.exact,"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }